import React from 'react';
import * as rmd from 'material-ui';

import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import config from 'cfg';
import IconSocial from 'material-ui/svg-icons/social/mood';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import IconCollapse from 'material-ui/svg-icons/navigation/expand-less';
import IconExpand from 'material-ui/svg-icons/navigation/expand-more';
import styled from 'styled-components';
import IconStyle from 'material-ui/svg-icons/image/style';
import auth from 'dash-front/auth';
let C_DEFAULT_TEMPLATE = 'C_DEFAULT_TEMPLATE';

const SMToolbarTitle = styled.span`
    font-size: 26px;
    line-height: 36px;
    font-weight: 300;
    padding-left: 5px;
    padding-right: 15px;
`;

var TemplateObserver = function(px) {
    this.template = null;
    this.subscriptions = [];
};

TemplateObserver.prototype.getTemplate = function() {
    return this.template;
};

TemplateObserver.prototype.setTemplate = function(template) {
    this.template = template;
    _.values(this.subscriptions).forEach(f => f());
};

TemplateObserver.prototype.subscribe = function(f) {
    this.subscriptions.push(f);
};

TemplateObserver.prototype.unsubscribe = function(func) {
    this.subscriptions = _.filter(this.subscriptions, f => {
        return f !== func;
    });
};

class SMBrowser extends React.Component {
    constructor(props, context) {
        super(props, context);
        var allParams = _.extend(
            {},
            props.params || {},
            _.reduce(props.router.routes, (m, p) => _.extend(m, p.params), {})
        );
        this.state = {
            templates: [],
            campaigns: [],
            widgets: [],
            sport: allParams.sport || 'football'
        };
        this.templateObserver = new TemplateObserver();
        this.loadData();
    }

    getChildContext = () => {
        return {
            templateObserver: this.templateObserver,
            campaigns: this.state.campaigns,
            widgets: this.state.widgets
        };
    };

    componentWillReceiveProps = nextProps => {
        var allParams = _.extend(
            {},
            nextProps.params,
            _.reduce(this.props.router.routes, (m, p) => _.extend(m, p.params), {})
        );
        if (allParams.sport !== this.state.sport) {
            this.setState(
                {
                    sport: allParams.sport
                },
                () => {
                    this.loadData();
                }
            );
        }
    };

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    static childContextTypes = {
        templateObserver: PropTypes.object,
        campaigns: PropTypes.array,
        widgets: PropTypes.array
    };

    loadData = additionalStateParams => {
        var user = this.context.user;
        if (!user || !user.client) return null;
        let sportId = RCore.sportToId(this.state.sport || 'football');

        let isF1 = this.state.sport === 'f1';
        const authToken = auth.getAccessToken();

        let lastUsedTemplate = localStorage.getItem(C_DEFAULT_TEMPLATE);

        return RCore.promiseProps({
            templates: fetch(`/api/templates/list?access_token=${authToken}`).then(response => response.json()),
            campaigns: fetch(`${config.campaign_manager.host}/api/campaigns?access_token=${authToken}`)
                .then(response => response.json())
                .then(r => r.campaigns)
                .catch(e => []),

            widgets: fetch(
                `${config.dash.api.host}/api/widgets/spec?access_token=${authToken}&template=${lastUsedTemplate}`
            )
                .then(response => response.json())
                .then(resp => resp.widgets),

            tournaments:
                !isF1 &&
                fetch(`${config.apis.ss2}/tournaments?sportId=${sportId}`)
                    .then(response => response.json())
                    .then(tournaments => {
                        var tournamentsList = _.filter(
                            tournaments,
                            t => t.isTop === true || config.triggerer.supportedLeagues.indexOf(t.id) !== -1
                        );
                        if (tournamentsList.length === 0)
                            tournamentsList = _.chain(tournaments)
                                .filter(t => t.isActive)
                                .sortBy(t => t.rank)
                                .take(10)
                                .value();
                        return tournamentsList;
                    }),
            gpxs: isF1 && fetch(`${config.apis.ss2}/f1/gpx`).then(response => response.json())
        })
            .then(result => {
                var template =
                    _.find(result.templates, t => {
                        return t.id === localStorage.getItem(C_DEFAULT_TEMPLATE);
                    }) || _.last(result.templates);

                this.templateObserver.setTemplate(template.id);
                this.setState({
                    ...result,
                    template,
                    isLoading: false,
                    ...additionalStateParams
                });
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    error: e,
                    isLoading: false,
                    ...additionalStateParams
                });
            });
    };

    renderSportSubMenu = () => {
        let { sport, tournaments, gpxs, templates, template } = this.state;
        let params = this.props.params;
        let selectedTournament = _.find(tournaments, t => t.id === +params.tournamentId);

        let smbTournaments = _.get(this.context.user, 'props.smbTournaments');
        if (!_.isArray(smbTournaments) || smbTournaments.length === 0) smbTournaments = tournaments.map(t => t.id);
        switch (sport) {
            case 'f1':
                return (
                    <div style={{ background: '#ccc' }}>
                        {gpxs &&
                            gpxs.map(gpx => {
                                let selected = +params.gpId === +gpx.id;
                                return (
                                    <rmd.FlatButton
                                        key={+gpx.id}
                                        onClick={value => {
                                            this.props.router.push(`/sm/browser/${sport}/gpx/${gpx.id}`);
                                        }}
                                        primary={selected}
                                        label={gpx.country}
                                    />
                                );
                            })}
                    </div>
                );
            default:
                return (
                    selectedTournament && (
                        <div title={selectedTournament && selectedTournament.name}>
                            <div>
                                {smbTournaments.map(tid => _.find(tournaments, t => t.id === tid)).map(t => {
                                    let tname = t.name.replace(t.countryName, '').trim();
                                    return (
                                        <rmd.RaisedButton
                                            key={t.id}
                                            onClick={e => {
                                                this.props.router.push(
                                                    `/sm/browser/${params.sport}/tournaments/${t.id}`
                                                );
                                            }}
                                            primary={selectedTournament && selectedTournament.id === t.id}
                                            label={tname}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )
                );
        }
    };

    render() {
        let { templates, template, tournaments, sport } = this.state;
        if (!template) return <div>loading</div>;
        var nestedParams = _.clone(this.props.params);

        _.reduce(
            this.props.routes,
            (sum, item) => {
                return _.extend(sum, item.params);
            },
            nestedParams
        );

        return (
            <div>
                <div id="hostforstylemanager" />

                {!nestedParams.disableTemplateChange && (
                    <div>
                        <rmd.SelectField
                            value={this.state.template && this.state.template.id}
                            floatingLabelFixed
                            floatingLabelText="Template"
                            style={{ margin: '0 auto' }}
                            onChange={(event, index, val) => {
                                localStorage.setItem(C_DEFAULT_TEMPLATE, val);
                                this.templateObserver.setTemplate(val);
                                let template = _.find(templates, t => t.id === val);
                                this.setState({
                                    template
                                });
                            }}
                        >
                            {templates.filter(t => (this.state.showHidden ? t.isHidden : !t.isHidden)).map((tpl, i) => {
                                return <rmd.MenuItem key={tpl.name} primaryText={tpl.name} value={tpl.id} />;
                            })}
                        </rmd.SelectField>
                    </div>
                )}
                {this.renderSportSubMenu()}
                {this.props.children}
            </div>
        );
    }
}

class SMBrowserMenu extends React.Component {
    constructor(props, context) {
        super(props, context);
        var allParams = _.extend(
            {},
            props.params || {},
            _.reduce(props.router.routes, (m, p) => _.extend(m, p.params), {})
        );
        this.state = {
            templates: [],
            sport: allParams.sport || 'football'
        };
    }

    componentWillReceiveProps = nextProps => {
        var allParams = _.extend(
            {},
            nextProps.params,
            _.reduce(this.props.router.routes, (m, p) => _.extend(m, p.params), {})
        );
        if (allParams.sport !== this.state.sport) {
            this.setState({
                sport: allParams.sport
            });
        }
    };

    handleOpenSport = (sport, e) => {
        this.props.router.push(`/sm/browser/${sport}`);
    };
    render() {
        let { sport } = this.state;
        let btnStyle = { height: '64px', color: '#fff' };

        let sports = {
            football: { label: 'Football', icon: <IconSocial /> }
            // handball: { label: 'Handball', icon: <IconSocial /> },
            // hockey: { label: 'Hockey', icon: <IconSocial /> },
            // f1: { label: 'F1', icon: <IconSocial /> }
        };

        return (
            <div>
                {_.keys(sports).map(btnSport => {
                    let selected = btnSport === sport;

                    return (
                        <rmd.FlatButton
                            key={btnSport + '_' + selected}
                            style={_.extend({}, btnStyle, selected && { backgroundColor: '#00BCD4' })}
                            onClick={this.handleOpenSport.bind(this, btnSport)}
                            {...sports[btnSport]}
                        />
                    );
                })}
            </div>
        );
    }
}

export default SMBrowser;
export { SMBrowserMenu };



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/SMBrowser.js
 **/